import { TbLoader } from "react-icons/tb";
import useIsLoadingStore from "store/isLoading";
import "./loading.scss";

export default function Loading() {
  const isLoading = useIsLoadingStore((state) => state.isLoading);

  return (
    <>
      <div hidden={!isLoading}>
        <div className="modal-layout " style={{ zIndex: 111 }}>
          <div className="load min-w-[200px] min-h-[40px]">
            <TbLoader size={26} />
            <h4 className="p-2  text-base flex justify-center items-center">
              {"Loading ..."}
            </h4>
          </div>
        </div>
      </div>
    </>
  );
}
